<template>
  <div class="main-top-margin">
    <v-tabs
        @change="changeTab"
        v-model="activeTab"
        background-color="transparent"
        color="#26262A"
        slider-color="#26262A"
        class="tabs-primary"
        :hide-slider="false"
        slider-size="2"
      >
        <v-tab><lang t="BUNDLE-ATTRIBUTE-ITEMS-TAB"></lang></v-tab>
        <v-tab><lang t="ATTRIBUTE-ITEMS-TAB"></lang></v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab"  class=" mt-2">

      <v-tab-item class="py-6 pt-12">
        <AttributeList :items="bundleAttributeItems" :is-bundle-attribute="true" :isLoading="loading" @addAttribute="addAttribute" @deleteItem="deleteItem" />
      </v-tab-item>

      <v-tab-item class="py-6 pt-12">
        <AttributeList :items="attributeItems" :isLoading="loading" :is-bundle-attribute="false" @addAttribute="addAttribute" @deleteItem="deleteItem" />
      </v-tab-item>

      </v-tabs-items>

  

  </div>
</template>

<script>
import AttributeList from './AttributeList.vue';
import {cloneDeep} from 'lodash';
import SimpleChip from '../../../components/ui-elements/SimpleChip.vue';
export default {
  name: 'AttributesIndex',
  components:{
    AttributeList,
    SimpleChip
  },
  data: () => ({
    loading: false,
    activeTab: 0,
    bundleAttributeItems: [],
    attributeItems: []
  }),

  computed: {
    units() {
      return ["mm", "g"];
    },

    types() {
      return ["number", "enum", "string", "boolean", "image"];
    },

    currentLangShortCode() {
      return this.$store.getters.langShortcode;
    }
  },

  created() {
    this.initialize();
  },

  mounted() {},

  methods: {

  

    initialize() {
      this.loading = true;
      this.$store.commit('RESET_IS_BUNDLE_ATTRIBUTE');
      this.axios.get("attributes").then((res) => {
        const items = res.data;
        this.bundleAttributeItems = cloneDeep(items).filter((el) => el.isBundleAttribute);
        this.attributeItems = cloneDeep(items).filter((el) => el.isItemAttribute);
        this.axios.get("calculationrules").then((res) => {
          this.calculationRules = res.data;
        });
        this.loading = false;
      });
    },

    deleteItem(item) {
      this.$confirm(
        this.$t("GLOBAL-CONFIRMATION-DELETE-MSG", { NAME: item.name }),
        {
          title: this.$t("GLOBAL-CONFIRMATION-DELETE-TITLE"),
          buttonTrueText: this.$t("GLOBAL-CONFIRMATION-DELETE-YES"),
          buttonFalseText: this.$t("GLOBAL-CONFIRMATION-DELETE-CANCEL"),
        }
      ).then((res) => {
        if (res) {
          this.axios.delete("attributes/" + item.id).then((res) => {
            this.initialize();
            this.$store.dispatch("setSnackbar", {
              text: this.$t("GLOBAL-SUCCESSFULLY_DELETED"),
            });
          });
        }
      });
    },

    addAttribute(isBundleAttribute){
      this.$store.commit('SET_IS_BUNDLE_ATTRIBUTE', isBundleAttribute);
      this.$router.push({name: 'settings-attributes-item'})
    }
    
  },
};
</script>

<style lang="scss" scoped>
.v-tabs-items{
  background-color: transparent;
}
</style>
